<template>
    <div class="box">
        <div class="content">
            <div class="instructions">
                <h2 class="title">{{data.title}}</h2>
                <p>资料分类：{{data.classType}} </p>
                <p>专业：{{data.industry}} </p>
                <p v-if="type">类型：{{filetype}}</p>
                <p v-if="!type">文件地址：{{data.webAddress}}</p>
                <p>详细介绍： <span v-html="data.content"></span></p>
                </div>
            </div>
            <div class="toolBox"> 
                <Button v-if="type" type="success" class="btn" @click="downLoad">下载</Button>
                <Button @click="cancel" class="btn" type="primary">返回</Button>
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    props: {
        id: {

        }
    },
    data() {
        return {
            data: {}
        }
    },
    computed: {
        filetype() {
            if(this.data.type) {
                // debugger
                // let type = this.data.type.toLowerCase();
                // let data = ""
                // for(let i in Base.FILE_TYPE){
                //     if(Base.FILE_TYPE[i].includes(type)) {
                //         data = i
                //     }
                // }
                // return data
                return this.data.type
            }
        },
        type() {
            return this.data.upLoadType === 'true'
        }
    },
    methods: {
        _initData() {
            let data = {
                id: this.id
            }
            this.$api.video.findFile(data).then(res => {
                this.data = res.data
            })
        },
        cancel() {
            this.$emit('cancel')
        },
        downLoad() {
            window.open('/api/file/acquisition/'+this.data.fileId)
        }
    },
    mounted() {
        this._initData()
    }
}
</script>

<style lang="scss" scoped>
    .box{
        box-shadow: 10px 10px 5px #888888;
        padding: 40px;
    }
    .toolBox{
        margin-bottom: 20px;
        margin-top: 20px;
        padding-top: 10px;
        padding-left: 10px;
    }
    .content{
        // border-bottom: 1px solid #dddddd;
        padding-bottom: 20px;
        &::after {
            content: "";
            display: block;
            height: 0;
            clear: both;
            visibility: hidden;
        }
        .videoBox{
            float: left;
        }
        .instructions{
            // width: 400px;
            float: left;
            font-size: 16px;
            line-height: 32px;
            padding-left: 20px;
            .title{
                margin-bottom: 20px;
                border-bottom: 1px solid #dddddd;
            }
        }
    }
    .toolBox{
        border-top: 1px solid #dddddd;
    }
    .btn{
        margin-top: 20px;
        margin-left: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/File/CaseInfo.vue